// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__3XlBK","spin":"style_spin__2u0ID"};